const locale = navigator.language ?? 'en-US'

export const addUtcTimezoneSuffix = (
    time: string,
    offsetMinutes: number,
    noParens?:'no-parens'
) => {
    const sign = offsetMinutes < 0 ? '-' : '+'
    const abs = Math.abs(offsetMinutes)
    const hours = String(Math.floor(abs / 60)).padStart(2, '0')
    const minutes = String(abs % 60).padStart(2, '0')
    const offsetStr = noParens
        ? `UTC${sign}${hours}:${minutes}`
        : `(UTC${sign}${hours}:${minutes})`

    return `${time} ${offsetStr}`
}

export const getProductTime = (offset: number) => {
    if (!offset == null || typeof offset !== 'number') return

    const date = new Date()
    const currentUtcOffsetMilliseconds = date.getTimezoneOffset() * 60 * 1000
    const utcTime = date.getTime() + currentUtcOffsetMilliseconds

    const offsetInMilliseconds = offset * 60 * 1000
    const localFormatted = new Date(
        utcTime + offsetInMilliseconds
    ).toLocaleString(locale)

    return addUtcTimezoneSuffix(localFormatted, offset)
}

export const getSameDatetimeLocalFormatWithUTC = (isoTime: string) => {
    if (!isoTime || typeof isoTime !== 'string') return null

    const datetimeOnly = isoTime.slice(0, 19)
    const date = new Date(datetimeOnly)
    const localFormatted = date.toLocaleString(locale)

    const offsetMatch = isoTime.match(/([+-]\d{2}):?(\d{2})$/)
    const utcSuffix = offsetMatch ? `(UTC${offsetMatch[0]})` : ''

    return `${localFormatted} ${utcSuffix}`
}

export const convertToProductTimeLocalFormatWithUTC = (
    isoTime: string,
    offsetMinutes: number
) => {
    if (!isoTime || typeof isoTime !== 'string') return null

    const datetimeOnly = isoTime.slice(0, 19)
    const utcDate = new Date(datetimeOnly)
    const shiftedDate = new Date(utcDate.getTime() + offsetMinutes * 60 * 1000)
    const localFormatted = shiftedDate.toLocaleString(locale)

    return addUtcTimezoneSuffix(localFormatted, offsetMinutes)
}

